import type {
  ClosedColumnModel,
  CreatedColumnModel,
  UpdatedColumnModel,
} from '../../../../../models/column-model/system/timestamp'
import type {TableDataType} from '../../../table-data-type'
import type {ClipboardColumnBehavior, ClipboardEntry} from '../types'

type TimestampColumnModel = CreatedColumnModel | UpdatedColumnModel | ClosedColumnModel

export const behavior: ClipboardColumnBehavior<TimestampColumnModel> = {
  readContent: (row: TableDataType, column: TimestampColumnModel): ClipboardEntry | undefined => {
    const timestampValue = row.columns[column.id]
    if (!timestampValue) return

    const {dataType} = column
    switch (dataType) {
      case 'created':
      case 'updated':
      case 'closed':
        return {
          text: timestampValue.value,
          dataType,
          value: timestampValue,
        }
    }
  },
}
